export const SET_SIDEBAR_AVAILABILITY = 'SET_SIDEBAR_AVAILABILITY'
export const SHOW_SIDEBAR = 'SHOW_SIDEBAR'
export const HIDE_SIDEBAR = 'HIDE_SIDEBAR'
export const SHOW_MENU = 'SHOW_MENU'
export const HIDE_MENU = 'HIDE_MENU'
export const CLEAR_SIDEBAR_OPTIONS = 'CLEAR_SIDEBAR_OPTIONS'
